module.exports = __webpack_public_path__ + "img/p1_l.20d66bb3.jpg";